import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Camera, DollarSign, RefreshCcw, ImageIcon } from "lucide-react";

interface KpiOpportunitiesSectionProps {
  metrics?: {
    camerasOpportunity: number;
    revenueOpportunity: number;
    arrOpportunity: number;
    imagesOpportunity: number;
  };
}

export const KpiOpportunitiesSection = ({ metrics }: KpiOpportunitiesSectionProps) => {
  const formatCurrency = (value: number) => {
    return new Intl.NumberFormat('en-GB', {
      style: 'currency',
      currency: 'GBP',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(value);
  };

  const formatNumber = (value: number) => {
    return new Intl.NumberFormat('en-GB').format(value);
  };

  return (
    <div className="space-y-4">
      <div className="flex items-center gap-2">
        <span className="inline-block w-3 h-3 rounded-full bg-teal-extraLight border border-teal/20" />
        <h2 className="text-2xl font-semibold text-foreground">Pipeline (Opportunities)</h2>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        <Card className="bg-teal-extraLight">
          <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
            <CardTitle className="text-sm font-medium text-muted-foreground">
              Cameras
            </CardTitle>
            <Camera className="h-4 w-4 text-muted-foreground" />
          </CardHeader>
          <CardContent>
            <div className="text-3xl font-bold text-foreground">
              {formatNumber(metrics?.camerasOpportunity || 0)}
            </div>
          </CardContent>
        </Card>

        <Card className="bg-teal-extraLight">
          <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
            <CardTitle className="text-sm font-medium text-muted-foreground">
              Revenue
            </CardTitle>
            <DollarSign className="h-4 w-4 text-muted-foreground" />
          </CardHeader>
          <CardContent>
            <div className="text-3xl font-bold text-foreground">
              {formatCurrency(metrics?.revenueOpportunity || 0)}
            </div>
          </CardContent>
        </Card>

        <Card className="bg-teal-extraLight">
          <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
            <CardTitle className="text-sm font-medium text-muted-foreground">
              ARR
            </CardTitle>
            <RefreshCcw className="h-4 w-4 text-muted-foreground" />
          </CardHeader>
          <CardContent>
            <div className="text-3xl font-bold text-foreground">
              {formatCurrency(metrics?.arrOpportunity || 0)}
            </div>
          </CardContent>
        </Card>

        <Card className="bg-teal-extraLight">
          <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
            <CardTitle className="text-sm font-medium text-muted-foreground">
              Images
            </CardTitle>
            <ImageIcon className="h-4 w-4 text-muted-foreground" />
          </CardHeader>
          <CardContent>
            <div className="text-3xl font-bold text-foreground">
              {formatNumber(metrics?.imagesOpportunity || 0)}
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};
